const WS_BASE = process.env.REACT_APP_BACKEND_URL?.replace('https://', 'wss://').replace('http://', 'ws://') || 'ws://localhost:8001';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = {};
    this.connectCallbacks = [];
    this.room = null;
    this.shouldReconnect = false;
    this.reconnectTimer = null;
  }

  connect(room) {
    if (this.socket) {
      this.disconnect();
    }

    this.room = room;
    this.shouldReconnect = true;
    this._open();
    return this.socket;
  }

  _open() {
    if (!this.room) return;
    const url = `${WS_BASE}/api/ws/${this.room}`;
    try {
      this.socket = new WebSocket(url);
    } catch (e) {
      console.error('WebSocket connection error:', e);
      this._scheduleReconnect();
      return;
    }

    this.socket.onopen = () => {
      console.log('WebSocket connected to room:', this.room);
      this.connectCallbacks.forEach((cb) => {
        try { cb(); } catch (e) { /* noop */ }
      });
    };

    this.socket.onmessage = (evt) => {
      try {
        const { event, data: eventData } = JSON.parse(evt.data);
        if (event) this.emit(event, eventData);
      } catch (err) {
        // ignore non-JSON / echo frames
      }
    };

    this.socket.onclose = () => {
      console.log('WebSocket disconnected');
      this._scheduleReconnect();
    };

    this.socket.onerror = () => {
      try { this.socket.close(); } catch (e) { /* noop */ }
    };
  }

  _scheduleReconnect() {
    if (!this.shouldReconnect || this.reconnectTimer) return;
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this._open();
    }, 3000);
  }

  disconnect() {
    this.shouldReconnect = false;
    this.connectCallbacks = [];
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.socket) {
      try { this.socket.close(); } catch (e) { /* noop */ }
      this.socket = null;
    }
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  onConnect(callback) {
    this.connectCallbacks.push(callback);
  }

  off(event, callback) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
  }

  emit(event, data) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach(callback => callback(data));
  }
}

const wsService = new WebSocketService();
export default wsService;
